/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

import { IWLDCommunicationPreferences } from './DataServiceEntities.g';
import { getCommunicationPreferencesStatusAsync } from './DataActionExtension.g';

/**
 * GetEmailSubscriptionsInput Input Action
 */
export class GetEmailSubscriptionsInput implements Msdyn365.IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `EmailSubscriptions`;
    public getCacheObjectType = () => 'EmailSubscriptions';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createEmailSubscripionsInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetEmailSubscriptionsInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetEmailSubscriptionsInput, ctx: Msdyn365.IActionContext): Promise<IWLDCommunicationPreferences> {
    // TODO: Uncomment the below line to get the value from a service
    const res = await getCommunicationPreferencesStatusAsync({ callerContext: ctx });
    return res;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IWLDCommunicationPreferences>>action,
    // TODO: Give your data action a unique id
    id: 'GetEmailSubscriptions',
    input: createEmailSubscripionsInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
